import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { brand, text } from '@guardian/source/foundations';
import { SvgInfoRound } from '@guardian/source/react-components';
import { wrapperStyles, iconStyles, messageWrapperStyles, messageStyles, contextStyles } from './styles.js';
const InfoSummary = ({ message, context, cssOverrides, ...props }) => /* @__PURE__ */ jsxs("div", { css: [wrapperStyles(brand[500]), cssOverrides], ...props, children: [
        /* @__PURE__ */ jsx("div", { css: iconStyles(brand[500]), children: /* @__PURE__ */ jsx(SvgInfoRound, {}) }),
        /* @__PURE__ */ jsxs("div", { css: messageWrapperStyles, children: [
                /* @__PURE__ */ jsx("div", { css: messageStyles(text.primary), children: message }),
                context && /* @__PURE__ */ jsx("div", { css: contextStyles, children: context })
            ] })
    ] });
export { InfoSummary };
